/**
* 基础菜单 营销管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>营销管理</el-breadcrumb-item>
        <el-breadcrumb-item>秒杀管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.sale_name" placeholder="商品销售名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_code" placeholder="商品编码" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="addflashdialog" class="add-button">新增</el-button>
        <el-button size="small" type="info" @click="editflashdialog" class="edit-button">修改</el-button>
        <!--        <el-button size="small" type="danger" @click="delflash">删除</el-button>-->
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="sale_name" label="销售名称" min-width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_code" label="商品编码" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="flash_price" label="秒杀价" width="80">
        </el-table-column>
        <el-table-column prop="flash_stock_num" label="秒杀数量" width="80">
        </el-table-column>
        <el-table-column prop="flash_sale_num" label="已成交数" width="80">
        </el-table-column>
        <el-table-column prop="un_pay_num" label="待付款数" width="80">
        </el-table-column>
        <el-table-column prop="begin_time" label="开始时间" width="135">
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间" width="135">
        </el-table-column>
        <el-table-column prop="creater_name" label="创建人" width="160" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="135">
        </el-table-column>
        <el-table-column prop="status" label="有效状态" width="80">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row.id,scope.row.status)"
              active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="seq" label="排序号" width="85">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="addflashDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form :model="flashForm" :rules="rules" ref="flashForm" label-width="155px" class="flashForm">
        <el-form-item label="商品销售名称" prop="sale_id" class="relative">
          <el-select v-model="flashForm.sale_id" filterable placeholder="请选择商品销售名称" clearable  :disabled="isDisable"
                     remote :filter-method="remoteMethod" class="productInterval" :popper-append-to-body="false"
                     @focus="focusProductName()" @change="changeProductName()" @clear="clear()">
            <el-option :title="item.sale_name"
                       v-for="item in productData"
                       :key="item.sale_id"
                       :label="item.sale_name"
                       :value="item.sale_id">
            </el-option>
            <div class="pagination-absolute">
              <el-pagination :small="small" style="height: 30px;margin-top: 8px"
                             @size-change="productHandleSizeChange"
                             @current-change="productHandleCurrentChange"
                             :current-page.sync="productCurrentPage"
                             :page-size="productPagesize"
                             layout="total, prev, pager, next"
                             :total="productTotalSize">
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="秒杀价" prop="flash_price" class="relative">
          <el-input v-model="flashForm.flash_price" clearable maxlength="8" placeholder="请输入秒杀价">
          </el-input>
        </el-form-item>
        <el-form-item label="秒杀数量" prop="flash_stock_num" class="relative">
          <el-input v-model="flashForm.flash_stock_num" auto-complete="off" maxlength="8" clearable placeholder="请输入秒杀数量">
          </el-input>
        </el-form-item>
        <el-form-item label="秒杀开始时间" prop="begin_time">
          <template>
            <div class="block">
              <el-date-picker :disabled="isDisable"
                v-model="flashForm.begin_time"
                type="datetime"
                placeholder="选择秒杀开始时间">
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="秒杀结束时间" prop="end_time">
          <template>
            <div class="block">
              <el-date-picker :disabled="isDisable"
                v-model="flashForm.end_time"
                type="datetime"
                placeholder="选择秒杀结束时间">
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="排序号" prop="seq">
          <el-input v-model="flashForm.seq" auto-complete="off" maxlength="8" clearable placeholder="请输入3以上的数字">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm('flashForm')">{{param2}}</el-button>
            <el-button type="primary" @click="saveSort('flashForm')">{{param}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import {
  flashList,
  flashAdd,
  flashUpdate,
  flashDisable,
  productSaleList,
  flashEnabled,
  flashDetail, custInfo
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToTime} from '../../utils/util'

  export default {
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入秒杀数量'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      var validateSeq = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入排序号'));
        } else if (!(/(^[1-9]\d*$)/.test(value))||value < 3) {
          return callback(new Error('请输入3以上的正整数'));
        } else {
          return callback();
        }
      };
      var validateSalePrice = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入秒杀价'));
        } else if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(value))) {
          return callback(new Error('输入长度过长或格式不正确'));
        } else {
          return callback();
        }
      };
      return {
        loading: false,
        addflashDialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        param: '',   // 按钮
        param2: '',   // 按钮
        status: true,
        voucherType: [],  // 优惠券类型
        productId: '',
        formInline: {
          page: 1,
          rows: 10,
          sale_name: '',
          product_code: ''
        },
        flashForm: {
          id: '',
          sale_id: '',
          flash_price: '',
          flash_stock_num: '',
          begin_time: '',
          end_time: '',
          seq:''
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        sale_id: '',
        // rules表单验证
        rules: {
          sale_id: [{required: true, message: '请选择商品销售名称', trigger: 'blur'}],
          flash_price: [{required: true, validator: validateSalePrice, trigger: 'blur'}],
          flash_stock_num: [{required: true, validator: validateNum, trigger: 'blur'}],
          begin_time: [{required: true, message: '选择秒杀开始时间', trigger: 'blur'}],
          end_time: [{required: true, message: '选择秒杀结束时间', trigger: 'blur'}],
          seq: [{required: true, validator: validateSeq, trigger: 'blur'}],
        },
        selectedsaleName: '',
        saleName: '',
        selectTableData: [],
        productData: [],
        productCurrentPage: 1,
        productPagesize: 10,
        productTotalSize: 0,
        small: true,
        isDisable:false,
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    mounted() {

    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      clear() {
        this.getProduct()
        this.productCurrentPage = 1
        this.saleName = ''
      },
      productHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.productPagesize = val;
        this.getProduct(this.saleName)
      },
      productHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.productCurrentPage = val;
        this.getProduct(this.saleName)
      },
      focusProductName() {
        if (!this.selectedsaleName) {
          this.saleName = ''
          this.getProduct('')
        }
      },
      changeProductName() {
        this.productCurrentPage = 1;
        this.productData.forEach((item) => {
          if (item.sale_id == this.flashForm.sale_id) {
            this.selectedsaleName = item.sale_name;
            this.getProduct(item.sale_name)
          }
        })
      },
      getProduct(saleName) {
        let parameter = {
          page: this.productCurrentPage,
          rows: 10,
          keyword: saleName,
          put_away_status: '75',
        };
        productSaleList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.rows.length) {
                this.selectedsaleName = ''
              }
              this.productData = res.rows;
              this.productTotalSize = res.total;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      remoteMethod(val) {
        this.productCurrentPage = 1
        this.saleName = val;
        this.getProduct(val)
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      handleClose() {
        this.$refs["flashForm"].resetFields();
        this.addflashDialogVisible = false;
      },
      changeStatus(id, status) {
        if (!status) {
          flashDisable(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          flashEnabled(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }

      },
      // 新增秒杀商品弹窗
      addflashdialog() {
        this.addflashDialogVisible = true;
        this.dialogTitle = '新增秒杀商品';
        this.selectedsaleName = '';
        this.flashForm = {
          id: '',
          sale_id: '',
          flash_price: '',
          flash_stock_num: '',
          begin_time: '',
          end_time: '',
          seq:''
        };
        this.param = '保存';
        this.param2 = '重置';
        this.isDisable = false;
      },
      // 修改秒杀商品弹窗
      editflashdialog() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.addflashDialogVisible = true;
        this.dialogTitle = '修改秒杀商品';
        this.param = '确定修改';
        this.param2 = '取消';
        this.isDisable = true;
        this.getProduct(this.selectTableData[0].product_code)
        flashDetail(this.selectTableData[0].id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.flashForm.id = res.content.id;
                this.flashForm.sale_id = res.content.sale_id;
                this.flashForm.flash_price = res.content.flash_price;
                this.flashForm.flash_stock_num = res.content.flash_stock_num;
                this.flashForm.begin_time = res.content.begin_time;
                this.flashForm.end_time = res.content.end_time;
                this.flashForm.seq = res.content.seq;
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        this.selectedsaleName = this.selectTableData[0].sale_name;
      },
      // 删除弹窗
      delflash() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否删除秒杀商品？';
        this.$confirm(title, '删除秒杀商品', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.loading = true;
          flashDisable(this.selectTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      getdata(parameter) {
        this.loading = true
        flashList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 新增优惠券规则
      saveSort(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.flashForm.begin_time) {
              this.flashForm.begin_time = timestampToTime(this.flashForm.begin_time)
            }
            if (this.flashForm.end_time) {
              this.flashForm.end_time = timestampToTime(this.flashForm.end_time)
            }
            if (this.flashForm.flash_stock_num) {
              this.flashForm.flash_stock_num = Number(this.flashForm.flash_stock_num)
            }
            this.loading = true;
            if (this.dialogTitle == '新增秒杀商品') {
              flashAdd(this.flashForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功新增秒杀商品'
                    });
                    this.addflashDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            } else {
              this.loading = true;
              flashUpdate(this.flashForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改秒杀商品'
                    });
                    this.addflashDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false;
                  this.$message.error('网络错误,请稍后再试!')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      resetForm(formName) {
        if (this.dialogTitle == '新增秒杀商品') {
          this.$refs[formName].resetFields();
          this.getProduct('')
        } else {
          this.addflashDialogVisible = false;
        }
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline);
        if(sale_name, sta) {

        }
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.product_name == cell.innerText || row.sale_name == cell.innerText || row.product_code == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }

</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .flashForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .flashForm .el-input {
    width: 320px;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .flashForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .flashForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .flashForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/views/Marketing/flashManage.vue